import { jsx as _jsx } from "react/jsx-runtime";
import { LoadingText } from 'seagull';
import { useLocaleKeys } from '~/i18n';
export const AiWorkingOnIt = (param)=>{
    let { label, testId, className } = param;
    const { t } = useLocaleKeys();
    const resolvedLabel = label !== null && label !== void 0 ? label : t.common.aiWorkingOnItLabel();
    const ariaLabel = typeof resolvedLabel === 'string' ? resolvedLabel : undefined;
    return /*#__PURE__*/ _jsx("div", {
        "data-testid": testId,
        "aria-label": ariaLabel,
        className: className,
        children: /*#__PURE__*/ _jsx(LoadingText, {
            variant: "paragraph1",
            weight: "normal",
            skin: "magical",
            children: resolvedLabel
        })
    });
};
